<div class="product-element-top">
  <a class="product-image-link" [routerLink]="['/product', product().slug]">
    <img [src]="product().imageUrl" [alt]="product().imageAlt" width="526" height="671" />
  </a>
  @if (salePercent(product().price, product().compareAtPrice); as percent) {
    <div class="product-labels labels-rounded">
      <span class="onsale product-label">-{{ percent }}%</span>
    </div>
  }
</div>

<h3 class="product-title">
  <a [routerLink]="['/product', product().slug]">{{ product().name }}</a>
</h3>
<div class="wrap-price">
  <div class="wrapp-swap">
    <div class="swap-elements">
      <span class="price">
        @if (product().compareAtPrice && product().compareAtPrice! > product().price) {
          <del aria-hidden="true">
            <span class="woocommerce-Price-amount amount">
              <bdi
                ><span class="woocommerce-Price-currencySymbol">$</span
                >{{ product().compareAtPrice | number: '1.2-2' }}</bdi
              >
            </span>
          </del>
          <ins>
            <span class="woocommerce-Price-amount amount">
              <bdi
                ><span class="woocommerce-Price-currencySymbol">$</span
                >{{ product().price | number: '1.2-2' }}</bdi
              >
            </span>
          </ins>
        } @else {
          <span class="woocommerce-Price-amount amount">
            <bdi
              ><span class="woocommerce-Price-currencySymbol">$</span
              >{{ product().price | number: '1.2-2' }}</bdi
            >
          </span>
        }
      </span>
      <div class="btn-add">
        <a
          href="#"
          class="button product_type_simple add_to_cart_button"
          (click)="onAdd($event)"
        >
          Add to cart
        </a>
      </div>
    </div>
  </div>
</div>
